import { Link } from 'react-router-dom';
import { IMG, OUTLETS, MENU_CATEGORIES, SITE } from '../data/site';
import Stamp from '../components/Stamp';
import Flakes from '../components/Flakes';
import Notice from '../components/Notice';
import OutletCard from '../components/OutletCard';

export default function HomePage() {
  const signature = MENU_CATEGORIES[0].items;
  return (
    <>
      {/* HERO */}
      <section data-testid="hero" className="relative bg-[#1F140E] grain text-[#FDFBF7] overflow-hidden">
        <Flakes />
        <div className="relative z-10 mx-auto max-w-6xl px-5 pt-14 pb-20 lg:pt-24 lg:pb-28 grid gap-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-7">
            <p className="reveal font-pricemono text-[11px] sm:text-xs tracking-[0.25em] uppercase text-[#E5A83B]">
              Rumah Makan · Kepatihan Kulon, Surakarta
            </p>
            <h1 className="reveal reveal-1 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.08] tracking-tight mt-5">
              Ayam Kampung Goreng <span className="italic text-[#E5A83B]">Kremes</span> Khas Solo,
              Sejak 1973
            </h1>
            <p className="reveal reveal-2 mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-[#E8DCC9]">
              Lebih dari lima dekade, Widuran menggoreng ayam kampung pilihan hingga keemasan dan
              menaburnya dengan kremesan gurih yang renyah — cita rasa klasik Solo yang dijaga
              lintas generasi di Jalan Sutan Syahrir.
            </p>
            <div className="reveal reveal-3 mt-9 flex flex-wrap gap-4">
              <Link
                to="/menu/"
                data-testid="hero-cta-menu"
                className="inline-flex items-center bg-[#C84B27] text-[#FDFBF7] font-semibold px-7 py-3.5 rounded-md shadow-md hover:bg-[#a93d1f] transition-colors active:scale-95"
              >
                Lihat Menu
              </Link>
              <Link
                to="/lokasi/"
                data-testid="hero-cta-lokasi"
                className="inline-flex items-center border-2 border-[#E5A83B] text-[#E5A83B] font-semibold px-7 py-3.5 rounded-md hover:bg-[#E5A83B] hover:text-[#1F140E] transition-colors active:scale-95"
              >
                Kunjungi Outlet
              </Link>
            </div>
            <p className="reveal reveal-3 mt-7 text-xs text-[#B09E88]">
              Catatan: seluruh produk kami non-halal — kami menyatakannya secara terbuka untuk
              kenyamanan Anda.
            </p>
          </div>
          <div className="lg:col-span-5 relative">
            <div className="relative mx-auto max-w-sm lg:max-w-none">
              <img
                src={IMG.hero}
                alt="Ayam kampung goreng keemasan dengan taburan kremesan renyah khas Widuran Solo"
                width="1200"
                height="900"
                fetchPriority="high"
                className="arch w-full aspect-[4/5] object-cover border-4 border-[#E5A83B]/40 shadow-2xl"
              />
              <img
                src={IMG.sambal}
                alt="Sambal pendamping ayam goreng khas rumah makan Widuran"
                width="1000"
                height="750"
                loading="lazy"
                className="hidden sm:block absolute -left-10 bottom-10 w-36 aspect-[4/3] object-cover rounded-lg border-4 border-[#FDFBF7] shadow-xl -rotate-6"
              />
              <div className="absolute -top-6 -right-4 sm:-right-8">
                <Stamp size={128} dark />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Notice variant="band" />

      {/* SIGNATURE MENU — receipt ticket */}
      <section data-testid="signature-menu" className="bg-[#F5EFE6] py-20 sm:py-28">
        <div className="mx-auto max-w-6xl px-5 grid gap-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <p className="font-pricemono text-[11px] tracking-[0.25em] uppercase text-[#C84B27]">
              Andalan Sejak 1973
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#2B1B12] tracking-tight mt-4">
              Tiga yang Tak Pernah Ditinggalkan
            </h2>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#6E6259]">
              Ayam kampung yang digoreng perlahan hingga kulitnya garing, lalu ditaburi kremesan —
              serpihan gurih keemasan yang menjadi tanda tangan setiap piring Widuran.
            </p>
            <Link
              to="/menu/"
              data-testid="signature-cta-menu"
              className="mt-8 inline-flex items-center border-2 border-[#2B1B12] text-[#2B1B12] font-semibold px-6 py-3 rounded-md hover:bg-[#2B1B12] hover:text-[#FDFBF7] transition-colors active:scale-95"
            >
              Lihat Daftar Menu Lengkap
            </Link>
          </div>
          <div className="lg:col-span-7">
            <div className="ticket max-w-xl mx-auto rounded-t-lg shadow-xl px-7 sm:px-10 pt-9 pb-12 rotate-[-0.5deg]">
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="font-pricemono text-xs tracking-[0.25em] uppercase text-[#8C4A11]">
                  Widuran · Solo
                </h3>
                <span className="font-pricemono text-xs text-[#8C4A11]">EST. 1973</span>
              </div>
              <p className="font-display text-2xl font-bold text-[#2B1B12] mt-2">Menu Andalan</p>
              <ul className="mt-6">
                {signature.map((m, i) => (
                  <li
                    key={m.name}
                    className={`py-4 flex items-baseline justify-between gap-4 ${i > 0 ? 'ticket-dash' : ''}`}
                  >
                    <div>
                      <p className="font-semibold text-[#1A110B]">{m.name}</p>
                      <p className="text-sm text-[#6E6259] mt-0.5">{m.desc}</p>
                    </div>
                    <span className="font-pricemono font-semibold text-[#8C4A11] whitespace-nowrap">
                      {m.price}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="ticket-dash mt-2 pt-4 text-[11px] leading-relaxed text-[#6E6259]">
                Harga ± mengacu pada pemberitaan media per Mei 2025 dan dapat berubah. Harga terkini
                tersedia di outlet.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* KREMESAN STORY */}
      <section data-testid="kremesan-story" className="relative bg-[#1F140E] grain text-[#FDFBF7] py-20 sm:py-28 overflow-hidden">
        <Flakes />
        <div className="relative z-10 mx-auto max-w-6xl px-5 grid gap-12 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={IMG.ayamGoreng}
                alt="Potongan ayam kampung goreng renyah khas Widuran Solo"
                width="1000"
                height="750"
                loading="lazy"
                className="rounded-lg w-full aspect-[3/4] object-cover"
              />
              <img
                src={IMG.nasiDaun}
                alt="Sajian nasi dengan lauk khas rumah makan Jawa"
                width="1000"
                height="750"
                loading="lazy"
                className="rounded-lg w-full aspect-[3/4] object-cover mt-10"
              />
            </div>
          </div>
          <div className="lg:col-span-6 order-1 lg:order-2 lg:pl-6">
            <p className="font-pricemono text-[11px] tracking-[0.25em] uppercase text-[#E5A83B]">
              Rahasia Kerenyahan
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-4">
              Kremesan: Serpihan Gurih yang Melegenda
            </h2>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#E8DCC9]">
              Kremesan Widuran digoreng dari adonan berbumbu hingga mengembang menjadi serpihan
              tipis nan renyah. Ditabur di atas ayam kampung goreng hangat, dipadukan sambal bawang
              atau sambal matah dan lalapan segar — perpaduan yang membuat pelanggan kembali sejak
              1973.
            </p>
            <p className="mt-4 text-base leading-relaxed text-[#CBBBA6]">
              Tersedia pula ayam bakar berbumbu manis-gurih, kepala ayam, rempela ati, serta layanan
              nasi box dan frozen food untuk dibawa pulang.
            </p>
            <Link
              to="/tentang/"
              data-testid="kremesan-cta-tentang"
              className="mt-8 inline-flex items-center text-[#E5A83B] font-semibold hover:text-[#FDFBF7] transition-colors"
            >
              Baca cerita kami <span aria-hidden="true" className="ml-2">→</span>
            </Link>
          </div>
        </div>
      </section>

      {/* OUTLETS */}
      <section data-testid="home-outlets" className="bg-[#FDFBF7] py-20 sm:py-28">
        <div className="mx-auto max-w-6xl px-5">
          <div className="max-w-2xl">
            <p className="font-pricemono text-[11px] tracking-[0.25em] uppercase text-[#C84B27]">
              Tiga Rumah Kami
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#2B1B12] tracking-tight mt-4">
              Mampir ke Widuran Terdekat
            </h2>
            <p className="mt-4 text-base leading-relaxed text-[#6E6259]">
              Dua outlet di Kota Solo dan satu cabang di Denpasar, Bali. Jam operasional dapat
              berubah — pantau Instagram resmi kami.
            </p>
          </div>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {OUTLETS.map((o) => (
              <OutletCard key={o.id} outlet={o} />
            ))}
          </div>
        </div>
      </section>

      {/* CLOSING CTA */}
      <section data-testid="home-closing" className="relative bg-[#F5EFE6] border-t border-[#E2D3BE] py-20">
        <div className="mx-auto max-w-6xl px-5 flex flex-col md:flex-row md:items-center gap-10 justify-between">
          <div className="max-w-xl">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#2B1B12] tracking-tight">
              Lapar? Kursi Kami Selalu Terbuka.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-[#6E6259]">
              Datang langsung ke Jalan Sutan Syahrir, atau pesan nasi box untuk acara Anda melalui
              Instagram resmi {SITE.name}.
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <a
              data-testid="closing-cta-instagram"
              href={SITE.instagram.solo}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-[#2B1B12] text-[#FDFBF7] font-semibold px-7 py-3.5 rounded-md hover:bg-[#3a281c] transition-colors active:scale-95"
            >
              Pesan via Instagram
            </a>
            <Link
              to="/kontak/"
              data-testid="closing-cta-kontak"
              className="inline-flex items-center border-2 border-[#2B1B12] text-[#2B1B12] font-semibold px-7 py-3.5 rounded-md hover:bg-[#2B1B12] hover:text-[#FDFBF7] transition-colors active:scale-95"
            >
              Hubungi Kami
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
